import ScalarFloatingBackdrop_vue_vue_type_script_setup_true_lang_default from "./ScalarFloatingBackdrop.vue.script.js";
//#region src/components/ScalarFloating/ScalarFloatingBackdrop.vue
var ScalarFloatingBackdrop_default = ScalarFloatingBackdrop_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarFloatingBackdrop_default as default };

//# sourceMappingURL=ScalarFloatingBackdrop.vue.js.map